if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.querySelector('.product-media-modal__nav--prev')?.addEventListener('click', () => this.navigateMedia(-1));
        this.querySelector('.product-media-modal__nav--next')?.addEventListener('click', () => this.navigateMedia(1));
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      navigateMedia(direction) {
        const mediaItems = Array.from(this.querySelectorAll('.product-media-modal__content > [data-media-id]'));
        if (!mediaItems.length) return;
        let currentIndex = mediaItems.findIndex((item) => item.classList.contains('active'));
        if (currentIndex < 0) currentIndex = 0;
        const nextIndex = (currentIndex + direction + mediaItems.length) % mediaItems.length;
        mediaItems.forEach((item) => item.classList.remove('active'));
        const nextMedia = mediaItems[nextIndex];
        nextMedia.classList.add('active');
        const template = nextMedia.querySelector('template');
        const content = template ? template.content : null;
        if (nextMedia.nodeName == 'DEFERRED-MEDIA' && content && content.querySelector('.js-youtube')) {
          nextMedia.loadContent();
        }
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
